// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import PrivacyPolicyPage from "../pages/PrivacyPolicy/PrivacyPolicy";
const __wvcRoutePaths = ["/PrivacyPolicyPage", "/privacy-policy"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["home", "homepage", "post", "privacy-policy", "privacypolicypage", "terms-and-conditions", "termsandconditionspage"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      <Route path={__wvcRoutePaths[0]} element={<PrivacyPolicyPage />} />
      
      
      
      <Route path={__wvcRoutePaths[1]} element={<PrivacyPolicyPage />} />
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
